<payarc-page-header title="Analytics"></payarc-page-header>

<payarc-segmented [options]="rangeOptions" [value]="daySetActive" (valueChange)="onRangeChange($event)"></payarc-segmented>

<div class="pa-date-row">
  <span class="pa-date-row__pickers">
    <input
      [matDatepicker]="dpFrom"
      type="text"
      class="pa-date-input"
      [max]="toDate"
      readonly
      [(ngModel)]="fromDate"
      (click)="dpFrom.open()"
    />
    <mat-datepicker #dpFrom (closed)="setDateFrom()"></mat-datepicker>
    <i class="fa fa-arrow-right"></i>
    <input
      type="text"
      [max]="today"
      [matDatepicker]="dpTo"
      class="pa-date-input"
      readonly
      [(ngModel)]="toDate"
      (click)="dpTo.open()"
    />
    <mat-datepicker #dpTo (closed)="setDateFrom()"></mat-datepicker>
  </span>
  <span class="pa-date-row__units">
    <button
      type="button"
      *ngFor="let unit of dateUnit"
      [class.pa-date-row__unit--active]="unit.criteria === criteria"
      [attr.aria-pressed]="unit.criteria === criteria"
      class="pa-date-row__unit"
      (click)="criteria = unit.criteria; setUrls()"
      >{{ unit.text }}</button
    >
  </span>
</div>

<!-- app-details-loader's own .container-card is position:absolute; top:0; bottom:0 —
     it anchors to the nearest positioned ancestor, which without this wrapper is
     .page-container itself, covering the header/filters above instead of just this
     area. This div (position:relative, height matching [Height]) gives it a smaller
     containing block instead, local to this one usage — the shared component (used
     on 30+ other pages) is untouched. -->
<div class="pa-home-loader" *ngIf="loadFlag">
  <app-details-loader
    [Height]="'100%'"
    [LoaderMarginTop]="'19%'"
  ></app-details-loader>
</div>
<div *ngIf="!loadFlag">
  <!-- "Needs attention" hidden for now (pending product decision on what belongs here).
  <payarc-card *ngIf="notRespondedDisputes > 0 || (vampRatio !== null && vampRatio !== undefined)" class="pa-attn">
    <payarc-section-title label="Needs attention"></payarc-section-title>
    <payarc-inline-alert *ngIf="notRespondedDisputes > 0" variant="bad">
      {{ notRespondedDisputes }} dispute(s) not yet responded
    </payarc-inline-alert>
    <payarc-inline-alert *ngIf="vampRatio !== null && vampRatio !== undefined" [variant]="vampRatio >= vampRatioLimit ? 'bad' : 'good'">
      Dispute ratio {{ vampRatio }}% ({{ vampRatioLimit }}% limit)
    </payarc-inline-alert>
  </payarc-card>
  -->



  <payarc-section-title label="Key metrics"></payarc-section-title>
  <div class="kpi-row1">
    <div class="kpi-card kpi-card--hero">
      <span class="kpi-card__l">Net Sales</span>
      <span class="kpi-card__v">{{ (netSales || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
      <span class="kpi-card__sub">
        Total sales {{ (totalSales || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}
        less refunds {{ (totalRefunds || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}
      </span>
    </div>
    <div class="kpi-card" [style.--pa-accent]="'var(--pa-blue)'">
      <span class="kpi-card__l">Total Sales</span>
      <span class="kpi-card__v">{{ (totalSales || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
      <div class="kpi-card__second">
        <span>Average sale</span>
        <b>{{ (avg_revenue || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</b>
      </div>
    </div>
    <div class="kpi-card" [style.--pa-accent]="'var(--pa-mint)'">
      <span class="kpi-card__l">Transactions</span>
      <span class="kpi-card__v">{{ total_transactions || 0 | number }}</span>
      <div class="kpi-card__second">
        <span>Refunds</span>
        <b>{{ (totalRefunds || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }} · {{ refundPercentage || 0 }}%</b>
      </div>
    </div>
  </div>
  <div class="kpi-row2">
    <div class="kpi-card" [style.--pa-accent]="'var(--pa-amber)'">
      <div class="kpi-pair-head">
        <span class="kpi-card__l">Total Disputes</span>
        <span class="kpi-l2">New dispute %</span>
      </div>
      <div class="kpi-pair-vals">
        <span class="kpi-card__v">{{ kpiDisputesTotal }}</span>
        <span class="kpi-v2">{{ kpiDisputePercent }}%</span>
      </div>
      <div class="kpi-card__second" *ngIf="disputeNewCount !== null">
        <span>New · follow-ups</span>
        <b>{{ disputeNewCount }} · {{ disputeFollowUpCount }}</b>
      </div>
    </div>
    <div class="kpi-card" [style.--pa-accent]="'var(--pa-periwinkle)'">
      <div class="kpi-pair-head">
        <span class="kpi-card__l">Disputes Volume</span>
        <span class="kpi-l2">Of volume</span>
      </div>
      <div class="kpi-pair-vals">
        <span class="kpi-card__v">{{ (tv_disputes || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        <span class="kpi-v2">{{ pv_disputes || 0 }}%</span>
      </div>
    </div>
    <div class="kpi-card" [style.--pa-accent]="'var(--pa-blue-med)'">
      <div class="kpi-pair-head">
        <span class="kpi-card__l">Subscriptions</span>
        <span class="kpi-l2">Est. MRR</span>
      </div>
      <div class="kpi-pair-vals">
        <span class="kpi-card__v">{{ subActiveCount }} active</span>
        <span class="kpi-v2">{{ (subEstMrr || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
      </div>
      <div class="kpi-card__second">
        <span>{{ subTrialCount }} trial</span>
        <b>{{ subCanceledCount }} canceled</b>
      </div>
    </div>
  </div>

  <div class="pa-sales-row">
    <payarc-section-card heading="Sales over time" class="pa-sales-row__chart">
      <payarc-bar-chart *ngIf="salesBarCategories.length > 0" [categories]="salesBarCategories" [series]="salesBarSeries" prefix="$"></payarc-bar-chart>
      <payarc-empty-state *ngIf="salesBarCategories.length === 0" title="No sales in this period"></payarc-empty-state>
    </payarc-section-card>
    <payarc-section-card heading="Sales by card type" class="pa-sales-row__donut">
      <payarc-donut *ngIf="cardTypeSegments.length > 0" [segments]="cardTypeSegments"></payarc-donut>
      <payarc-empty-state *ngIf="cardTypeSegments.length === 0" title="No card-type data" message="No transactions in this period."></payarc-empty-state>
    </payarc-section-card>
  </div>

  <payarc-section-title label="Operations"></payarc-section-title>
  <div class="pa-ops-grid">

    <!-- "When you'll get paid — Deposits": commented out, not ready to ship — the mini table's
         date column rendered "Invalid date" for every row against real data (the API's date
         field/format for a DEPOSIT row_data entry doesn't parse the way effective_date does in
         the full deposits-report). Needs the real field/format confirmed before re-enabling;
         see extractDepositRows() in home.component.ts.
    <payarc-section-card heading="When you'll get paid — Deposits" [sub]="depositsPeriodTotal ? ('Period total: ' + (depositsPeriodTotal / 100 | currency : 'USD' : 'symbol' : '1.2-2')) : null">
      <a scard-action routerLink="/balance/deposits-report" class="pa-ops-link">View all →</a>
      <ng-container *ngIf="!depositsLoading && !depositsError">
        <table class="pa-deposit-tbl" *ngIf="depositsRows.length > 0">
          <tr *ngFor="let row of depositsRows">
            <td>{{ row.date | dateFormat : 'MM/dd/yyyy' }}</td>
            <td class="muted">{{ row.reference }}</td>
            <td class="num">{{ row.amount / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</td>
          </tr>
        </table>
        <payarc-empty-state *ngIf="depositsRows.length === 0" title="No settlements in this period"></payarc-empty-state>
      </ng-container>
      <payarc-empty-state *ngIf="depositsError" title="Deposits unavailable" message="Couldn't load deposit data for this period."></payarc-empty-state>
    </payarc-section-card>
    -->

    <payarc-section-card heading="Dispute resolution">
      <a scard-action routerLink="/disputes/dispute-list" class="pa-ops-link">View all →</a>
      <payarc-donut
        *ngIf="!disputeChartError && disputeDonutSegments.length > 0"
        [segments]="disputeDonutSegments"
        [centerValue]="disputeWinRate !== null ? disputeWinRate + '%' : null"
        centerLabel="win rate"
      ></payarc-donut>
      <payarc-empty-state *ngIf="!disputeChartLoading && !disputeChartError && disputeDonutSegments.length === 0" title="No disputes in this period"></payarc-empty-state>
      <payarc-empty-state *ngIf="disputeChartError" title="Dispute resolution unavailable"></payarc-empty-state>
    </payarc-section-card>

    <payarc-section-card heading="Dispute trend">
      <payarc-bar-chart
        *ngIf="!disputeChartError && disputeTrendSeries[0].values.length > 0"
        [categories]="disputeTrendCategories"
        [series]="disputeTrendSeries"
        prefix=""
      ></payarc-bar-chart>
      <payarc-empty-state *ngIf="!disputeChartLoading && !disputeChartError && disputeTrendSeries[0].values.length === 0" title="No dispute trend data"></payarc-empty-state>
      <payarc-empty-state *ngIf="disputeChartError" title="Dispute trend unavailable"></payarc-empty-state>
    </payarc-section-card>

    <payarc-section-card heading="Where volume went">
      <div class="pa-vol">
        <div class="pa-vol__bar">
          <span class="pa-vol__seg" [style.background]="'var(--pa-mint)'" [style.width.%]="totalSales ? (netSales / totalSales) * 100 : 0"></span>
          <span class="pa-vol__seg" [style.background]="'var(--pa-coral)'" [style.width.%]="totalSales ? (totalRefunds / totalSales) * 100 : 0"></span>
          <span class="pa-vol__seg" [style.background]="'var(--pa-blue-light)'" [style.width.%]="totalSales ? (tv_disputes / totalSales) * 100 : 0"></span>
        </div>
        <ul class="pa-vol__legend">
          <li><span class="pa-dot" [style.background]="'var(--pa-mint)'"></span>Net sales <b>{{ (netSales || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</b></li>
          <li><span class="pa-dot" [style.background]="'var(--pa-coral)'"></span>Refunded <b>{{ (totalRefunds || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</b></li>
          <li><span class="pa-dot" [style.background]="'var(--pa-blue-light)'"></span>Disputed <b>{{ (tv_disputes || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</b></li>
        </ul>
      </div>
    </payarc-section-card>

    <payarc-section-card heading="Recent activity" [style.grid-column]="showVamp ? 'span 4' : '1 / -1'">
      <a scard-action routerLink="/events-and-logs" class="pa-ops-link">View all →</a>
      <payarc-empty-state *ngIf="activityError" title="Activity feed unavailable"></payarc-empty-state>
      <payarc-empty-state *ngIf="!activityLoading && !activityError && recentActivity.length === 0" title="No recent activity"></payarc-empty-state>
      <ul class="pa-feed" *ngIf="!activityError && recentActivity.length > 0">
        <li class="pa-feed__item" *ngFor="let a of recentActivity">
          <span class="pa-feed__text">{{ a.description ? (a.description | camalizeStr : true) : '--' }}</span>
          <span class="pa-feed__time">{{ a.created_at | dateFormat : 'MM/dd/yyyy hh:mm' }}</span>
        </li>
      </ul>
    </payarc-section-card>

    <payarc-section-card *ngIf="showVamp" heading="VAMP">
      <a scard-action routerLink="/vamp-details" class="pa-ops-link">View all →</a>
      <payarc-gauge *ngIf="!vampError && vampRatio !== null" [value]="vampRatio" [max]="5" [limit]="vampRatioLimit" label="VAMP ratio"></payarc-gauge>
      <payarc-empty-state *ngIf="!vampLoading && !vampError && vampRatio === null" title="No VAMP summary for this account"></payarc-empty-state>
      <payarc-empty-state *ngIf="vampError" title="VAMP data unavailable" message="Try again later."></payarc-empty-state>
    </payarc-section-card>

    <payarc-section-card *ngIf="showAchRejects" heading="Top ACH reject reasons" [sub]="achReasons.length + ' rejected item(s)'">
      <a scard-action routerLink="/ach-rejects/ach-rejects-list" class="pa-ops-link">View all →</a>
      <payarc-empty-state *ngIf="achError" title="ACH rejects unavailable"></payarc-empty-state>
      <payarc-empty-state *ngIf="!achLoading && !achError && achReasons.length === 0" title="No ACH rejects"></payarc-empty-state>
      <ul class="pa-rank" *ngIf="!achError && achReasons.length > 0">
        <li *ngFor="let r of achReasons">
          <span class="pa-rank__label">{{ r.label }}</span>
          <b class="pa-rank__value">{{ r.amount | currency : 'USD' : 'symbol' : '1.2-2' }}</b>
        </li>
      </ul>
    </payarc-section-card>

    <payarc-section-card heading="Recent transactions" [style.grid-column]="'1 / -1'" [flush]="true">
      <a scard-action routerLink="/payment/payment-list" class="pa-ops-link">View all →</a>
      <payarc-empty-state *ngIf="txnsError" title="Transactions unavailable"></payarc-empty-state>
      <payarc-empty-state *ngIf="!txnsLoading && !txnsError && recentTransactions.length === 0" title="No transactions yet"></payarc-empty-state>
      <payarc-table *ngIf="!txnsError && recentTransactions.length > 0">
        <thead>
          <tr><th>Date</th><th>Card</th><th>Customer</th><th>Amount</th><th>Status</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of recentTransactions">
            <td>{{ t.created_at | dateFormat : 'MM/dd/yyyy hh:mm' }}</td>
            <td>
              <img class="pa-card-logo" [src]="cardImgObj[t.card?.data?.brand] || defaultCardImg" alt="" />
              •••• {{ t.card?.data?.last4digit || '----' }}
            </td>
            <td>{{ t.card?.data?.customer_id || '--' }}</td>
            <td>{{ (t.amount || 0) / 100 | currency : 'USD' : 'symbol' : '1.2-2' }}</td>
            <td><payarc-status-badge [status]="t.status"></payarc-status-badge></td>
          </tr>
        </tbody>
      </payarc-table>
    </payarc-section-card>

  </div>
</div>
